import ListMlPricingRules from './List'

export default ListMlPricingRules
